module.exports = __webpack_public_path__ + "img/llama.a279bf06.gif";